module.exports = __webpack_public_path__ + "img/music_lover--active.3b95987d.svg";